import { Box, Grid, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';

import GridContainer from '../components/container/GridContainer';
import Reservations from '../components/reservations/Reservations';
import { useStore } from '../store/context';
import LoadingSpinner from '../components/spinner/LoadingSpinner';

const ReservationsPage = observer((): JSX.Element => {
  // welcomeApi
  const { welcomeStore } = useStore();
  const { currentEstate } = welcomeStore;

  if (!currentEstate?.customerId) {
    return (
      <Box
        width="95vw"
        height="60vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box>
          <LoadingSpinner />
        </Box>
      </Box>
    );
  }

  return (
    <Box width="95vw">
      <GridContainer>
        <Grid container spacing={1} sx={{ marginTop: '10px' }}>
          <Grid item xs={12} md={12}>
            <Paper elevation={0}>
              <Reservations customerId={currentEstate?.customerId} />
            </Paper>
          </Grid>
        </Grid>
      </GridContainer>
    </Box>
  );
});

export default ReservationsPage;
